import React from 'react';
import { config } from '@keytrade/functions';

const { list: colors } = config.colors;

const InstagramIcon: React.FC = () => {
  return (
    <svg
      width='22'
      height='23'
      viewBox='0 0 22 23'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      aria-label='Instagram'
    >
      <path
        d='M16.4313 6.2595C16.2062 6.2595 16.0239 6.0771 16.0239 5.85209C16.0239 5.62709 16.2062 5.44469 16.4313 5.44469'
        stroke={colors.BlueDawn}
        strokeWidth='1.62963'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M16.4312 6.2595C16.6563 6.2595 16.8386 6.0771 16.8386 5.85209C16.8386 5.62709 16.6563 5.44469 16.4312 5.44469'
        stroke={colors.BlueDawn}
        strokeWidth='1.62963'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M1 5.91269C1 3.59837 2.87613 1.72223 5.19047 1.72223H16.3651C18.6794 1.72223 20.5556 3.59837 20.5556 5.91269V17.0873C20.5556 19.4016 18.6794 21.2777 16.3651 21.2777H5.19047C2.87613 21.2777 1 19.4016 1 17.0873V5.91269Z'
        stroke={colors.BlueDawn}
        strokeWidth='1.62963'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M6.62482 11.4998C6.62482 12.0452 6.73224 12.5853 6.94095 13.0891C7.14965 13.593 7.45556 14.0508 7.8412 14.4365C8.22684 14.8221 8.68466 15.128 9.18853 15.3367C9.69239 15.5454 10.2324 15.6528 10.7778 15.6528C11.3232 15.6528 11.8632 15.5454 12.3671 15.3367C12.871 15.128 13.3288 14.8221 13.7144 14.4365C14.1001 14.0508 14.406 13.593 14.6147 13.0891C14.8234 12.5853 14.9308 12.0452 14.9308 11.4998C14.9308 10.3984 14.4933 9.34208 13.7144 8.56324C12.9356 7.78441 11.8793 7.34686 10.7778 7.34686C9.67637 7.34686 8.62004 7.78441 7.8412 8.56324C7.06236 9.34208 6.62482 10.3984 6.62482 11.4998Z'
        stroke={colors.BlueDawn}
        strokeWidth='1.62963'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default InstagramIcon;
